"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PicturesSlider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/carousel--horizontal/32.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--left/32.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--right/32.js"));
var _4 = _interopRequireDefault(require("@carbon/icons-react/lib/close/32.js"));
var _breakpoints = _interopRequireDefault(require("../../common/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n:export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.picture {\n  margin-bottom: 48px; }\n  .picture .image-area {\n    height: 382px;\n    background: #f4f4f4;\n    margin-bottom: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n    .picture .image-area img {\n      max-height: 100%;\n      max-width: 100%; }\n  .picture p {\n    font-size: 12px;\n    min-height: 16px;\n    padding: 0 16px;\n    line-height: 16px; }\n  @media (max-width: 1055px) {\n    .picture .image-area {\n      height: 289px; } }\n  @media (max-width: 671px) {\n    .picture .image-area {\n      height: 194px; } }\n\n.pictures-gallery {\n  margin-bottom: 48px; }\n  .pictures-gallery .carousel {\n    height: 382px;\n    background: #f4f4f4;\n    margin-bottom: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n    .pictures-gallery .carousel .image-column {\n      width: 100%;\n      height: 100%; }\n      .pictures-gallery .carousel .image-column img {\n        max-width: 100%;\n        max-height: 100%;\n        position: relative;\n        top: 49.9%;\n        left: 50%;\n        transform: translateY(-50%) translateX(-50%); }\n        .pictures-gallery .carousel .image-column img:hover {\n          cursor: pointer; }\n    .pictures-gallery .carousel svg {\n      flex-shrink: 0;\n      margin: 0 1rem; }\n      .pictures-gallery .carousel svg:hover {\n        cursor: pointer; }\n  .pictures-gallery .content {\n    margin-top: 0;\n    margin-bottom: 0;\n    min-height: initial; }\n  .pictures-gallery p {\n    font-size: 12px;\n    min-height: 16px;\n    padding: 0 16px;\n    line-height: 16px;\n    margin-bottom: 16px; }\n  .pictures-gallery .page-info {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    color: #000000; }\n    .pictures-gallery .page-info svg {\n      margin-right: 0.5rem; }\n  .pictures-gallery .modal {\n    background: rgba(0, 0, 0, 0.7);\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    padding: 1.5rem 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n    .pictures-gallery .modal.single-image svg.previous,\n    .pictures-gallery .modal.single-image svg.next {\n      visibility: hidden; }\n    .pictures-gallery .modal svg {\n      color: white;\n      flex-shrink: 0; }\n      .pictures-gallery .modal svg.previous, .pictures-gallery .modal svg.next {\n        margin: 0 1rem; }\n      .pictures-gallery .modal svg:hover {\n        cursor: pointer; }\n    .pictures-gallery .modal .image-column {\n      position: relative;\n      width: 100%;\n      height: inherit; }\n      .pictures-gallery .modal .image-column .close {\n        position: absolute;\n        z-index: 1; }\n      .pictures-gallery .modal .image-column img {\n        max-width: 100%;\n        max-height: 100%;\n        position: relative;\n        top: 49.9%;\n        left: 50%;\n        transform: translateY(-50%) translateX(-50%);\n        padding: 3rem 0; }\n      .pictures-gallery .modal .image-column .page-info {\n        position: absolute;\n        color: #ffffff; }\n  @media (max-width: 1055px) {\n    .pictures-gallery .carousel {\n      height: 289px; }\n    .pictures-gallery .modal {\n      padding: 0; }\n      .pictures-gallery .modal .image-column img {\n        padding: 0; }\n      .pictures-gallery .modal .image-column svg.close {\n        background: rgba(244, 244, 244, 0.4);\n        color: #000000; } }\n  @media (max-width: 671px) {\n    .pictures-gallery .carousel {\n      height: 194px;\n      padding: 0; }\n    .pictures-gallery .carousel svg.previous,\n    .pictures-gallery .carousel svg.next,\n    .pictures-gallery .modal svg.previous,\n    .pictures-gallery .modal svg.next {\n      background: rgba(244, 244, 244, 0.4);\n      color: #000000; }\n    .pictures-gallery svg.previous, .pictures-gallery svg.next {\n      position: absolute;\n      z-index: 1; }\n    .pictures-gallery svg.previous {\n      left: 0; }\n    .pictures-gallery svg.next {\n      right: 0; } }\n";
  const fileName = "PicturesSlider_PicturesSlider";
  const element = document.querySelector("style[data-sass-component='PicturesSlider_PicturesSlider']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PicturesSlider = props => {
  const [page, setPage] = (0, _react.useState)(1);
  const [modalPage, setModalPage] = (0, _react.useState)(1);
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
  const imagesCount = props.images.length;
  const [modalClosePosition, setModalClosePosition] = (0, _react.useState)({
    left: null,
    top: null
  });
  const [modalPageInfoPosition, setModalPageInfoPosition] = (0, _react.useState)({
    left: null,
    top: null
  });
  const isSingleImage = props.images.length === 1;

  /**
   * Using some js calculations for positioning elements in modal, so that we can just use max-height/max-width CSS
   * for the modal image. Otherwise its very hard to dynamically use the full available space, shrinking, and
   * positioning the modal image in a div with other div siblings.
   */
  const positionModalElements = () => {
    const modalImage = document.querySelector('.modal img');
    if (!modalImage) {
      return;
    }
    const modalImageLeftCenter = modalImage.offsetLeft; // offsetLeft is center maybe due to CSS centering
    const modalImageHalfWidth = modalImage.width / 2;
    const modalImageHalfHeight = modalImage.height / 2;
    const modalImageLeftEnd = modalImageLeftCenter + modalImageHalfWidth;
    const modalImageTopCenter = modalImage.offsetTop;
    const modalImageTop = modalImageTopCenter - modalImageHalfHeight;
    const spacing = 16;
    const createModalClosePosition = () => {
      const isInMediumBreakpoint = document.querySelector('.modal').clientWidth < _breakpoints.default.large;
      if (isInMediumBreakpoint) {
        return {
          left: modalImageLeftEnd - closeIcon.clientWidth - spacing,
          top: modalImageTop + spacing
        };
      }
      return {
        left: modalImageLeftEnd - closeIcon.clientWidth,
        top: modalImageTop - closeIcon.clientHeight - spacing
      };
    };
    const closeIcon = document.querySelector('.modal svg.close');
    const pageInfo = document.querySelector('.modal .page-info');
    setModalClosePosition(createModalClosePosition());
    setModalPageInfoPosition({
      left: modalImageLeftCenter - pageInfo.clientWidth / 2,
      top: modalImageTopCenter + modalImageHalfHeight - pageInfo.clientHeight - 10
    });
  };
  (0, _react.useLayoutEffect)(() => {
    const event = 'resize';
    window.addEventListener(event, positionModalElements);
    const disableListener = () => window.removeEventListener(event, positionModalElements);
    return disableListener;
  });
  const preventSelectionOnDoubleClick = element => {
    const onMouseDown = mouseDownEvent => {
      mouseDownEvent.preventDefault();
      element.removeEventListener('mousedown', onMouseDown);
    };
    element.addEventListener('mousedown', onMouseDown);
  };
  const setPageByCarousel = (newPage, carouselType) => {
    if (carouselType === 'modal') {
      setModalPage(newPage);
      return;
    }
    setPage(newPage);
  };
  const next = (clickEvent, currentPage, carouselType) => {
    preventSelectionOnDoubleClick(clickEvent.target);
    const isCurrentlyLastPage = currentPage === imagesCount;
    const newPage = !isCurrentlyLastPage ? currentPage + 1 : 1;
    setPageByCarousel(newPage, carouselType);
  };
  const previous = (clickEvent, currentPage, carouselType) => {
    preventSelectionOnDoubleClick(clickEvent.target);
    const isCurrentlyFirstPage = currentPage === 1;
    const lastPage = imagesCount;
    const newPage = !isCurrentlyFirstPage ? currentPage - 1 : lastPage;
    setPageByCarousel(newPage, carouselType);
  };
  const currentImage = props.images[page - 1];
  const currentModalImage = props.images[modalPage - 1];
  const texts = [currentImage.description, currentImage.copyright ? `${props.translate('pictures-gallery.copyright')}: ${currentImage.copyright}` : null];
  const renderModal = () => {
    const classes = ['modal', isSingleImage ? 'single-image' : null];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.join(' ')
    }, /*#__PURE__*/_react.default.createElement(_2.default, {
      className: 'previous',
      onClick: clickEvent => previous(clickEvent, modalPage, 'modal')
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: 'image-column'
    }, /*#__PURE__*/_react.default.createElement(_4.default, {
      className: 'close',
      onClick: () => setIsModalOpen(false),
      style: modalClosePosition
    }), /*#__PURE__*/_react.default.createElement("img", {
      src: currentModalImage.src,
      onLoad: () => positionModalElements(),
      alt: ''
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: 'page-info',
      style: modalPageInfoPosition
    }, modalPage, " / ", imagesCount)), /*#__PURE__*/_react.default.createElement(_3.default, {
      className: 'next',
      onClick: clickEvent => next(clickEvent, modalPage, 'modal')
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'pictures-gallery'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'carousel'
  }, !isSingleImage && /*#__PURE__*/_react.default.createElement(_2.default, {
    className: 'previous',
    onClick: clickEvent => previous(clickEvent, page)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'image-column'
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: currentImage.src,
    alt: '',
    onClick: () => {
      setModalPage(page);
      setIsModalOpen(true);
    }
  })), !isSingleImage && /*#__PURE__*/_react.default.createElement(_3.default, {
    className: 'next',
    onClick: clickEvent => next(clickEvent, page)
  })), /*#__PURE__*/_react.default.createElement("p", null, texts.join(' ')), !isSingleImage && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'page-info'
  }, /*#__PURE__*/_react.default.createElement(_.default, null), " ", page, " / ", imagesCount)), isModalOpen && renderModal());
};
exports.PicturesSlider = PicturesSlider;
PicturesSlider.propTypes = {
  images: _propTypes.default.array.isRequired,
  translate: _propTypes.default.func.isRequired
};
var _default = exports.default = PicturesSlider;